if (!customElements.get("limit-notice-pp")) {
  customElements.define(
    "limit-notice-pp",

    class LimitNoticePP extends HTMLElement {
      constructor() {
        super();

        this.noticeTextTemplate =
          "You've reached the purchase limit for this [limit-type]";
        this.noticeActive = false;

        this.hasCustomText =
          this.dataset.hasCustomText === "true" ? true : false;

        let expiredHolidayShippingPresent =
          this.checkForHolidayShippingExpired();

        messenger.listen(messenger.topics.PP_LIMIT_MESSAGE_SHOW, (data) => {
          if (data.productId != this.productId) {
            return;
          }
          this.showNotice();
          if (!this.buyButton) {
            return;
          }
          if (data.limitStatus === "over") {
            this.buyButton.setAttribute("type", "button");
            this.buyButton.setAttribute("disabled", "disabled");
          } else {
            expiredHolidayShippingPresent =
              this.checkForHolidayShippingExpired();
            if (!expiredHolidayShippingPresent && !this.hasCustomText) {
              // console.log('setting buy button to submit');
              this.buyButton.setAttribute("type", "submit");
            } else {
              this.buyButton.setAttribute("type", "button");
            }
            this.buyButton.removeAttribute("disabled");
          }
        });

        messenger.listen(messenger.topics.PP_LIMIT_MESSAGE_HIDE, (data) => {
          if (data.productId != this.productId) {
            return;
          }
          this.hideNotice();
          if (this.buyButton) {
            expiredHolidayShippingPresent =
              this.checkForHolidayShippingExpired();
            // console.log(
            //   'expiredHolidayShippingPresent',
            //   expiredHolidayShippingPresent
            // );
            if (!expiredHolidayShippingPresent && !this.hasCustomText) {
              this.buyButton.setAttribute("type", "submit");
            } else {
              this.buyButton.setAttribute("type", "button");
            }
            this.buyButton.removeAttribute("disabled");
          }
        });
      }

      connectedCallback() {
        this.limitReached = false;
        const parent = this.parentElement;
        if (!parent) {
          console.error("Cannot find parent element!");
          return;
        }
        const grandParent = parent.parentElement;
        if (!grandParent) {
          console.error("Cannot find grandParent element!");
          return;
        }
        this.form = grandParent.querySelector("product-form");
        this.notice = this.querySelector(".limit-alert");
        if (!this.notice) {
          console.error("Cannot find notice element!");
          return;
        }
        this.buyButton = this.form ? this.form.querySelector("button") : null;
        /**
         * @type {HTMLElement | null}
         */
        this.closeX = this.notice.querySelector(
          ".limit_info_cart__close-button"
        );

        if (this.closeX) {
          this.closeX.addEventListener("click", () => this.hideNotice());
          this.closeX.tabIndex = -1;
        } else {
          console.log("Cannot find close-x element!");
        }

        const productScriptElement = this.querySelector(
          'script[type="application/json"]'
        );
        if (productScriptElement && productScriptElement.textContent) {
          this.product = JSON.parse(productScriptElement.textContent);
        } else {
          console.error("Cannot find product-script element!");
        }
        this.productId = this.product.id;
        this.vendor = this.product.vendor;

        this.productLimit = store.getLimitForProduct(this.product.id);
        this.brandLimit = store.getLimitForBrand(this.product.vendor);
        if (
          !this.productLimit &&
          !this.brandLimit &&
          window.enableGlobalProductLimit
        ) {
          this.productLimit = window.globalProductLimit;
        }
        this.limitType = this.productLimit ? "product" : "brand";

        this.hasExactlyOneOption =
          this.product.options.length === 1 ? true : false;
        this.isRenderedOnModalSwiper = this.closest("swiper-variants-mobile")
          ? true
          : false;

        this.initMessage();
      }

      async initMessage() {
        if (!this.notice) {
          console.error("Cannot find notice element!");
          return;
        }
        const limitText = this.notice.querySelector(".limit_text");
        if (!limitText) {
          console.error("Cannot find limit-text element!");
          return;
        }
        limitText.innerHTML = this.noticeTextTemplate
          .replace("[limit-type]", this.limitType)
          .replace(
            "[limit-qty]",
            this.limitType === "product"
              ? parseInt(this.productLimit)
              : parseInt(this.brandLimit)
          );
      }

      init() {
        // console.log('limit-notice init');
      }

      showNotice() {
        this.classList.add("limit-notice-pp--show");
        if (this.closeX) {
          this.closeX.tabIndex = 0;
        }
      }

      hideNotice() {
        this.classList.remove("limit-notice-pp--show");
        if (this.closeX) {
          this.closeX.tabIndex = -1;
        }
      }

      checkForHolidayShippingExpired() {
        const holidayShippingExpiredContainer = document.querySelector(
          ".holiday-shipping-expired-container"
        );
        // console.log(
        //   'holidayShippingExpiredContainer',
        //   holidayShippingExpiredContainer
        // );
        if (
          holidayShippingExpiredContainer &&
          holidayShippingExpiredContainer.style.display === "block"
        ) {
          return true;
        }
        return false;
      }
    }
  );
}
